import { on, reducer } from 'ts-action';
import { getLayoutMock } from '../../../tests/mocks/layout.mock';
import * as undoActions from '../../undo/actions/undo.actions';
import * as layoutActions from '../actions/layout.actions';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import { LayoutState } from '../types/layout-state.type';
import { RestingDisplay, isRestingDisplay } from '../../resting/resting.util';

export const DISPLAY_SYSTEM_KEY = 'displaySystem';

declare module 'react-redux' {
  interface DefaultRootState {
    layout: LayoutState;
  }
}

const getInitialState = (): LayoutState => {
  const displayFromLocalStorage = localStorage.getItem(
    DISPLAY_SYSTEM_KEY,
  ) as RestingDisplay;
  const display = isRestingDisplay(displayFromLocalStorage)
    ? displayFromLocalStorage
    : 'us';
  return getLayoutMock({ display });
};

export default reducer(
  getInitialState(),
  on(layoutActions.toggle, (state, { key }) => ({
    ...state,
    [key]: !state[key],
  })),
  on(layoutActions.update, (state, { update }) => {
    if (update.display != null) {
      localStorage.setItem(DISPLAY_SYSTEM_KEY, update.display);
    }
    return {
      ...state,
      ...update,
    };
  }),
  on(undoActions.undo, undoActions.restore, (state, { diff: { layout } }) => {
    if (!layout) {
      return state;
    }
    return { ...state, ...layout };
  }),
  on(ecgActions.clean, getInitialState),
);
